var _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotificationEmailInprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.717,
    height: 22.996,
    viewBox: "0 0 31.717 22.996",
    id: "svg245",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-785.813 -554)",
    id: "g243"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(785.812 549.518)",
    id: "g237"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.312 12.967)",
    id: "g231"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.847,20.219a.4.4,0,0,1-.273-.109L18.981,15.8a.4.4,0,1,1,.547-.581l4.593,4.309a.4.4,0,0,1-.274.69Z",
    transform: "translate(-8.116 -15.111)",
    fill: "#11526a",
    id: "path227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8,20.219a.4.4,0,0,1-.274-.69l4.595-4.309a.4.4,0,1,1,.547.581L6.074,20.111A.4.4,0,0,1,5.8,20.219Z",
    transform: "translate(-5.402 -15.112)",
    fill: "#11526a",
    id: "path229"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.76,22.082H2a2,2,0,0,1-2-2V6.478a2,2,0,0,1,2-2H22.76a2,2,0,0,1,2,2V20.086A2,2,0,0,1,22.76,22.082ZM2,5.28a1.2,1.2,0,0,0-1.2,1.2V20.086a1.2,1.2,0,0,0,1.2,1.2H22.76a1.2,1.2,0,0,0,1.2-1.2V6.478a1.2,1.2,0,0,0-1.2-1.2Z",
    transform: "translate(0 0)",
    fill: "#11526a",
    id: "path233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.511,15.448a2.232,2.232,0,0,1-1.466-.528L.8,5.978a.4.4,0,1,1,.524-.6l10.25,8.941a1.494,1.494,0,0,0,1.882,0L23.688,5.391a.4.4,0,1,1,.525.6L13.976,14.919A2.23,2.23,0,0,1,12.511,15.448Z",
    transform: "translate(-0.133 -0.161)",
    fill: "#11526a",
    id: "path235"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 810.42609,
    cy: 569.97632,
    r: 6.9980001,
    fill: "#ffffff",
    id: "circle239"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 810.42608,564.06547 a 5.9108466,5.9108466 0 1 0 5.91085,5.91085 5.9175174,5.9175174 0 0 0 -5.91085,-5.91085 z m 0,10.97728 a 5.06644,5.06644 0 0 1 0,-10.13287 v 5.06644 l 3.5808,3.58086 a 5.0506073,5.0506073 0 0 1 -3.5808,1.48557 z",
    id: "path3737",
    style: {
      strokeWidth: 0.422203,
      fill: "#eb8c34"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationEmailInprogress);
export default __webpack_public_path__ + "static/media/icon_notification_email_inprogress.2262712b63e528d391c524b59c0976c4.svg";
export { ForwardRef as ReactComponent };